import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import ListItemText from '@material-ui/core/ListItemText';
import Skeleton from '@material-ui/lab/Skeleton';
import Typography from '@material-ui/core/Typography';
import translations from '../../translations';

const HandlingListCardSkeleton = () => (
  <Card>
    <Box display="flex" alignItems="center">
      <Box flexGrow="1">
        <CardContent>
          <ListItemText
            primary={<Skeleton variant="text" width="40%" />}
            secondary={<Skeleton variant="text" width="30%" />}
          />
          <Box my={1}>
            <Typography variant="overline" color="textSecondary">
              <FormattedHTMLMessage {...translations.list.item.location} />
            </Typography>
            <Typography variant="body2" color="textPrimary">
              <Skeleton variant="text" width={16} />
            </Typography>
          </Box>
          <Grid container spacing={1}>
            <Grid item xs={3}>
              <Typography variant="overline" color="textSecondary">
                <FormattedHTMLMessage {...translations.list.item.itemCount} />
              </Typography>
              <Typography variant="body2" color="textPrimary">
                <Skeleton variant="text" width={16} />
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography variant="overline" color="textSecondary">
                <FormattedHTMLMessage {...translations.list.item.locationCount} />
              </Typography>
              <Typography variant="body2" color="textPrimary">
                <Skeleton variant="text" width={16} />
              </Typography>
            </Grid>
            <Grid item xs={5}>
              <Typography variant="overline" color="textSecondary">
                <FormattedHTMLMessage {...translations.list.item.shipmentCount} />
              </Typography>
              <Typography variant="body2" color="textPrimary">
                <Skeleton variant="text" width={16} />
              </Typography>
            </Grid>
          </Grid>
        </CardContent>
      </Box>
      <Box mx={1}>
        <IconButton>
          <Skeleton variant="circle" width={24} height={24} />
        </IconButton>
      </Box>
    </Box>
  </Card>
);

export default HandlingListCardSkeleton;
